// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwCommandBar from 'viewmodel/AwCommandBarViewModel';
import AwSidenav from 'viewmodel/AwSidenavViewModel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/appCtxService', () => import('js/appCtxService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {
    "sideNavRightData": {
      "slide": "PUSH",
      "direction": "RIGHT_TO_LEFT",
      "animation": false,
      "width": "WIDE",
      "height": "FULL"
    },
    "buttonCommand": {
      "action": "anAction",
      "iconName": "Add",
      "tooltip": "{{i18n.createRfq}}"
    }
  },
  "actions": {
    "openCreateRfqPopup": {
      "actionType": "Event",
      "method": "Event",
      "inputData": {
        "events": [{
          "name": "awsidenav.openClose",
          "eventData": {
            "id": "createRfqSidenavPushRight",
            "includeView": "CreateRfqCommandPanel",
            "commandId": "creatRfqSidenavPushCommand"
          }
        }]
      }
    },
    "performOnMountBatchAction": {
      "actionType": "batchJob",
      "steps": [{
        "action": "addSessionToCtx"
      }, {
        "action": "addCsIdToCtx"
      }]
    },
    "addSessionToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "rfq.accsessionid",
        "value": "{{props.accsessionid}}"
      }
    },
    "addCsIdToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "rfq.collaborationspaceid",
        "value": "{{props.collaborationspaceid}}"
      }
    }
  },
  "onEvent": [{
    "eventId": "create-rfq-event",
    "action": "openCreateRfqPopup",
    "cacheEventData": true
  }],
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    }
  },
  "lifecycleHooks": {
    "onMount": "performOnMountBatchAction"
  },
  "conditions": {},
  "i18n": {
    "createRfq": ["RfqMessages"],
    "quoteRequests": ["RfqMessages"]
  },
  "_viewModelId": "MyRfqs",
  "_uniqueViewModelId": "MyRfqs",
  "ctx": {}
};

/*
<div class="afx-content-background aw-layout-full sw-column">
    <header class="rfqHeader">{{i18n.quoteRequests}}</header>   
    <aw-flex-column class="rfqQuoteFlexColumn">
        <aw-flex-row class="rfqQuoteFlexHeightFill">
            <aw-flex-column class="rfqQuoteFlexWidthFill">
                <aw-command-bar show-command-labels="true" anchor="creatRfqSidenavPushCommandAnchor" alignment="HORIZONTAL"></aw-command-bar>
                <des-list-rfqs-as-list acc-session-id="{{props.accsessionid}}"
                collaborationspace-id="{{props.collaborationspaceid}}">
            </des-list-rfqs-as-list>
            </aw-flex-column>
            <aw-sidenav id="createRfqSidenavPushRight" config="data.sideNavRightData"></aw-sidenav>
        </aw-flex-row>
    </aw-flex-column>
</div>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full sw-column"
  }, /*#__PURE__*/React.createElement("header", {
    className: "rfqHeader"
  }, AwParseService.instance("i18n.quoteRequests")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })), /*#__PURE__*/React.createElement(AwFlexColumn, {
    className: "rfqQuoteFlexColumn"
  }, /*#__PURE__*/React.createElement(AwFlexRow, {
    className: "rfqQuoteFlexHeightFill"
  }, /*#__PURE__*/React.createElement(AwFlexColumn, {
    className: "rfqQuoteFlexWidthFill"
  }, /*#__PURE__*/React.createElement(AwCommandBar, {
    showCommandLabels: AwParseService.instance("true")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    anchor: "creatRfqSidenavPushCommandAnchor",
    alignment: "HORIZONTAL"
  }), /*#__PURE__*/React.createElement("des-list-rfqs-as-list", {
    "acc-session-id": AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "collaborationspace-id": AwParseService.instance("props.collaborationspaceid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  })), /*#__PURE__*/React.createElement(AwSidenav, {
    id: "createRfqSidenavPushRight",
    config: AwParseService.instance("data.sideNavRightData")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;